import React, { Fragment, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import AdPreviewCard from "./AdPreviewCard";
import DataStore from "../base/plumbing/DataStore";
import { space } from "../base/utils/miscutils";
import PropControl from '../base/components/PropControl';
import { MacroHelp } from './AdDesignExtraControls';
import { getType } from '../base/data/DataClass';

// listen
const doHandleMessage = e => {
	//console.warn("doHandleMessage", e);
	let data = null;
	try {
		data = JSON.parse(e.data);
	} catch {
		// oh well :)
		//console.warn("doHandleMessage", "Message ingnored");
	}
	// Don't lump this in the try-catch - if DataStore throws errors we want to know
	if (data !== null && getType(data) === 'XRay') {
		DataStore.setValue(["widget","xray"], data);
	}
};
window.addEventListener('message', doHandleMessage, false);


/**
 * A drop-in wrapper for AdPreviewCard
 * @param {*} param0 
 * @returns 
 */
function AdWysiwyg({advert, path, skipToEndCard}) {
	// NB: uses xray.js, which is inserted by GoodLoopUnit.jsx

	const widgetPath = ['widget', 'wysiwyg'];

	/*useEffect (() => {
		DataStore.setValue(widgetPath.concat("open", true));
	}, []);*/

	const open = DataStore.getValue(widgetPath.concat("open"));

	// // Does the page request a size?
	// let dims = analysis.size;
	// if (dims && dims.width) wprops.width = dims.width;
	// if (dims && dims.height) wprops.height = dims.height;
	let xray = DataStore.getValue("widget","xray");

	let [modalInfo, setModalInfo] = useState();
	if ( ! modalInfo) modalInfo = {}; // just to simplify the code below a little - no null checks needed
	let [iframe, setIframe] = useState();
	// copy modalInfo into DataStore so PropControl can access it
	DataStore.setValue(['widget','mi'], modalInfo, false);


	// The click-me overlays
	function Editor() {
		if (!xray) return null;
		let imgeds = [] // TODO soon - starting with text only - xray.imgs.map(ii => <ImgEditor key={JSON.stringify(ii)} info={ii} path={path} setModalInfo={setModalInfo} selected={JSON.stringify(modalInfo)===JSON.stringify(ii)} />);
		let spaneds = xray.spans && xray.spans.map(info => <SpanEditor key={JSON.stringify(info)} info={info} path={path} setModalInfo={setModalInfo} selected={modalInfo===info} />);
		return open ? <div className="wysiwyg-container">{[...imgeds, ...spaneds]}</div> : null;
	}

	/**
	 * Sets the DataStore value, and pokes the iframe.contentDocument. 
	 * Assumes modalInfo.id
	 */
	const setString = e => {
		console.warn("setString", e);
		const strPath = path.concat('customtext', modalInfo.id);
		if (modalInfo.id) {
			DataStore.setValue(strPath, modalInfo.rawText);
			if (iframe && iframe.contentDocument) {
				const doc = iframe.contentDocument;
				doc.querySelector(`[data-sid=${modalInfo.id}]`).innerHTML = modalInfo.rawText; // TODO process macros
				//iframe.postMessage(JSON.stringify({action:"setString",text:modalInfo.text,id:modalInfo.id}));
			} else console.warn("No iframe??");
		} else {
			console.error("How to set?!",modalInfo);
		}
	};
	// Backwards compatability Dec 2021 - can be removed soon
	if (modalInfo.type==="text") {
		if ( ! modalInfo.rawText) modalInfo.rawText = modalInfo.text;
	}

	return (
		<div data-debug="wysiwyg">
		<AdPreviewCard advert={advert} adid={advert.id} path={path} skipToEndCard={skipToEndCard} Editor={Editor} iframeCallback={setIframe}/>
		<PropControl type="checkbox" prop="open" path={widgetPath} label="Enable WYSIWYG editor"/>
		{xray && xray.backgrounds ? (
			xray.backgrounds.map(bg => <BGEditor key={JSON.stringify(bg)} bg={bg} setModalInfo={setModalInfo} selected={JSON.stringify(modalInfo)===JSON.stringify(bg)} />)
		) : null}

		<Modal animation="false" isOpen={ !! modalInfo.type} toggle={e => modalInfo? setModalInfo(null) : null} >
			<ModalHeader toggle={e => modalInfo? setModalInfo(null) : null}>{infoLabel(modalInfo)}</ModalHeader>
			<ModalBody>
				{modalInfo.type==="text" && <PropControl path={['widget','mi']} prop="rawText" saveFn={e => setString(e)} />}
				{modalInfo.type==="img" && <PropControl path={['widget','mi']} prop="src" type="imgUpload" />}
				{modalInfo.type==="background" && <PropControl path={['widget','mi']} prop="backgroundImage" type="imgUpload" />}
				{modalInfo.type==="background" && <PropControl path={['widget','mi']} prop="backgroundColor" label="Background color" />}
				{modalInfo.type==="text" && <MacroHelp />}
			</ModalBody>
		</Modal>
	</div>);
}


const editorStyle = (info, selected) => ({
	position: 'absolute',
	backgroundColor: selected && 'rgba(255,255,255,0.5)',
	top: `${info.y}px`,
	left: `${info.x}px`,
	width: `${info.width}px`,
	height: `${info.height}px`,
});


function ImgEditor({info, path, selected, setModalInfo}) {
  return <div onClick={e => setModalInfo(info)} className="wysiwyg-zone zone-img" style={editorStyle(info, selected, 'red')} />
}


function SpanEditor({info, path, selected, setModalInfo}) {
	return <div onClick={e => setModalInfo(info)} className="wysiwyg-zone zone-text" style={editorStyle(info, selected, 'green')} />;
}

const infoLabel = bg => bg && space(
	!bg.id && 'Warning: No Id!',
	bg.title && `Title: ${bg.title}`,
	bg.id && `ID: ${bg.id}`,
	bg.alt
);

/**
 * TODO an editor for background images
 * @param {*} param0 
 * @returns 
 */
function BGEditor({bg, setModalInfo, selected}) {
	return (<div onClick={e => setModalInfo(bg)} className={space(selected&&"selected")}>
		{infoLabel(bg)}
		{bg.backgroundImage && <img className="logo logo-xl" src={bg.backgroundImage} />}
		<span style={{backgroundColor:bg.backgroundColor}}> </span>
		</div>);
}

export default AdWysiwyg;
